import { Order } from '@diamond/shared/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { getOrderDetail } from '../queries/order';
import { useAuthStore } from '../stores';

export function getOrderDetailOptions(
  access_token: string,
  metaId: string,
  warehouse: string,
  shouldRunQuery = true
) {
  const runQuery =
    typeof metaId === 'string' &&
    typeof warehouse === 'string' &&
    shouldRunQuery;
  return queryOptions<Order>({
    queryKey: ['OrderDetail', metaId, warehouse],
    queryFn: () => getOrderDetail(access_token, metaId, warehouse),
    enabled: runQuery,
  });
}

export const useGetOrderDetail = (
  metaId: string,
  warehouse: string,
  shouldRunQuery = true
) => {
  const session = useAuthStore();

  return useQuery(
    getOrderDetailOptions(
      session.access_token,
      metaId,
      warehouse,
      shouldRunQuery
    )
  );
};
